// ======================================================================
// File Name       : LiveReservedListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues } from 'redux-form';
import moment from 'moment';
import * as UsageSettingLiveAction from '../../actions/UsageSettingLiveActions';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import LiveReservedSearch from '../../components/usageSettingLive/LiveReservedSearch';
import LiveReservedList from '../../components/usageSettingLive/LiveReservedList';
import { MESSAGE_TYPE, MESSAGE_FILTER } from '../../constants/MessageThreadContants';
import { LIVE_RESERVED_LIST, LIVE_RESERVED_DETAIL } from '../../constants/PathConstants';
import { RETURN_MAX_NUM, DEFAULT_DATE_FORMAT_SERVER } from '../../constants/index';
import * as actionType from '../../constants/actionTypes/page';
import * as ICON from '../../constants/IconConstants';
import * as Path from '../../constants/PathConstants';
import CustomLink from '../../components/button/CustomLink';

class LiveReservedListContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAllowShowSearchMessage: false,
    };
    this.initData = this.initData.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.searchData = this.searchData.bind(this);
    this.createParams = this.createParams.bind(this);
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
    this.goToDetail = this.goToDetail.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  componentWillMount() {
    this.props.dispatch(UsageSettingLiveAction.getLiveReservationTime()).then(() => {
      this.initData();
    });
  }

  initData() {
    const { initialValues } = this.props;
    let column = null;
    let startPosition = 0;
    if (initialValues) {
      if (initialValues.liveSortType) {
        column = initialValues.liveSortType;
      }
      if (initialValues.startPosition) {
        startPosition = initialValues.startPosition;
      }
    }
    const param = this.createParams(initialValues, startPosition, column);
    this.props.dispatch(UsageSettingLiveAction.getLiveReservedList(param));
  }

  searchData(startPosition, column) {
    const { formValues, invalid } = this.props;
    if (invalid) {
      return;
    }
    const param = this.createParams(formValues, startPosition, column);
    this.props.dispatch(UsageSettingLiveAction.getLiveReservedList(param)).then(() => {
      this.setState({ isAllowShowSearchMessage: true });
    });
  }

  onSearchBtnClick() {
    const { invalid } = this.props;
    if (invalid) return;
    this.props.change('startPosition', 0);
    this.searchData(0);
  }

  // #7120 START
  getStartEndData(startPosition) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    let column = null;
    if (formValues.liveSortType) {
      column = formValues.liveSortType;
    }
    this.searchData(startPosition, column);
  }

  handleSortState(column) {
    const { invalid, formValues } = this.props;
    if (invalid) return;
    this.searchData(null, column);
    let startPosition = null;
    if (formValues.startPosition) {
      startPosition = formValues.startPosition;
    }
    this.searchData(startPosition, column);
  }
  // #7120 END

  createParams(searchInfo, startPosition, column) {
    const paramSearchAttribute = {};
    const paramSearchInfo = {};
    if (searchInfo && Object.keys(searchInfo).length) {
      searchInfo.liveName && (paramSearchInfo.liveName = searchInfo.liveName);
      searchInfo.organizerUserName &&
        (paramSearchInfo.organizerUserName = searchInfo.organizerUserName);
      searchInfo.liveStartFrom &&
        (paramSearchInfo.liveStartFrom = moment(searchInfo.liveStartFrom)
          .startOf('day')
          .format('YYYY-MM-DD HH:mm'));
      searchInfo.liveStartTo &&
        (paramSearchInfo.liveStartTo = moment(searchInfo.liveStartTo)
          .endOf('day')
          .format('YYYY-MM-DD HH:mm'));
      paramSearchInfo.startPosition = searchInfo.startPosition || 0;
      paramSearchInfo.includeCompletedLive = searchInfo.includeCompletedLive ? 1 : 0;
      if (!isNaN(parseInt(searchInfo.liveFormat, 10))) {
        paramSearchInfo.liveFormat = searchInfo.liveFormat;
      }
      searchInfo.userAttributeKeyNum &&
        (paramSearchAttribute.userAttributeKeyNum = searchInfo.userAttributeKeyNum);
      searchInfo.userAttributeSearchText &&
        (paramSearchAttribute.userAttributeSearchText = searchInfo.userAttributeSearchText);
    }
    if (!isNaN(parseInt(startPosition, 10))) {
      paramSearchInfo.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      paramSearchInfo.ascendingDescendingSort = column.sortState;
      paramSearchInfo.liveSortType = column.sortBy;
    }
    paramSearchInfo.returnMaxNum = RETURN_MAX_NUM;
    return { paramSearchInfo, paramSearchAttribute };
  }

  goToDetail(liveSecernId) {
    const { invalid, formValues } = this.props;
    if (!invalid) {
      this.props.dispatch({
        type: actionType.SAVE_SEARCH_CONDITION,
        parentPath: LIVE_RESERVED_LIST,
        searchCondition: formValues,
      });
    }
    const path = LIVE_RESERVED_DETAIL.replace(':id', liveSecernId);
    this.props.history.push(path);
  }

  componentWillUnmount() {
    const { formValues } = this.props;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: LIVE_RESERVED_LIST,
      searchCondition: formValues,
    });
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  render() {
    const { liveReserves, liveReserveRecordNum, liveReservationTime, formValues } = this.props;
    const { hoverIndex } = this.state;
    return (
      <div>
        <MessageSearch
          recordNum={liveReserveRecordNum}
          resultList={liveReserves ? liveReserves.allSecernIds : []}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <LiveReservedSearch
          {...formValues}
          {...liveReservationTime}
          onSearchBtnClick={this.onSearchBtnClick}
        />
        <CustomLink
            className="margin-right-7 btn-register margin-right-10 margin-bottom-10"
            to={Path.LIVE_RESERVED_REGISTER}
            text="ライブの予約"
            icon={ICON.REGIST}
          />
        <LiveReservedList
          liveReserves={liveReserves}
          handleSortState={this.handleSortState}
          goToDetail={this.goToDetail}
          recordNum={liveReserveRecordNum}
          getStartEndData={this.getStartEndData}
          hoverIndex={hoverIndex}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { liveReservedListSearchForm } = state.form;
  const { parentPath, searchCondition } = state.page;
  const { liveReserves, liveReserveRecordNum, liveReservationTime } = state.usageSettingLive;
  let initial = {
    userAttributeKeyNum: 1,
    includeCompletedLive: 1,
  };
  if (parentPath === LIVE_RESERVED_LIST) {
    initial = searchCondition;
  }
  return {
    liveReserves,
    liveReserveRecordNum,
    liveReservationTime,
    liveReservedListSearchForm,
    invalid: isInvalid('liveReservedListSearchForm')(state),
    formValues: getFormValues('liveReservedListSearchForm')(state),
    initialValues: initial,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'liveReservedListSearchForm',
    touchOnChange: true,
  })(LiveReservedListContainer),
);
